import {
  ActualConsumptionInput,
  CookingSessionInput,
  FoodRecipe,
  IngredientInput,
  MealsWorkspace,
  ShoppingItemInput
} from '../models/meals-workspace.model';

export abstract class MealsWorkspaceRepository {
  abstract load(): Promise<MealsWorkspace>;
  abstract saveIngredient(input: IngredientInput, id?: number): Promise<number>;
  abstract saveRecipe(
    recipe: Pick<FoodRecipe, 'title' | 'instructions'>,
    ingredients: { ingredient_id: number; quantity: number | null }[],
    id?: number
  ): Promise<void>;
  abstract listMealAxes(): Promise<Array<{id:number;name:string}>>;

  abstract createSession(input: CookingSessionInput): Promise<number>;
  abstract updateSession(input: CookingSessionInput): Promise<void>;
  abstract setSessionCooked(
    id: number, cooked: boolean,
    weights?: { session_recipe_id: number; weight_g: number }[]
  ): Promise<void>;
  abstract savePlannedConsumption(input: ActualConsumptionInput, title: string, id?: number, axisId?: number | null): Promise<void>;
  abstract confirmPlannedConsumption(id: number, input: ActualConsumptionInput): Promise<void>;
  abstract recordConsumption(input: ActualConsumptionInput): Promise<void>;
  abstract updateConsumption(id: number, input: ActualConsumptionInput): Promise<void>;
  abstract deleteEntity(kind: 'ingredient' | 'recipe' | 'consumption' | 'session', id: number): Promise<void>;
  abstract createShoppingList(name: string): Promise<number>;
  abstract addShoppingItems(listId: number, items: ShoppingItemInput[]): Promise<number>;
}
